import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../constants/DropdownOptions";
import * as farmActions from "../../../modules/farmManagement/action";
import "../../../style";
import { formatDate } from "../../../utils/DateFormatter";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";




class FarmsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        farmId: "Farm Id",
        farmName: "Sub-Farm Name",
        address: "Address",
        farmSize: "Farm Size"
      },
      order: "desc",
      orderBy: "id"
    };
  }
  componentDidMount() {
    const {selectedYear} = this.props
    if(this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      this.props.actions.getAllSubFarmsList(this.props.MainFarmId);
    } 
     else if(!isSuperAdmin()){
      this.props.actions.getAllFarmsList(selectedYear);
     }   
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.FarmsList &&
      this.props.FarmsList !== nextProps.FarmsList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear
    ) {
      this.props.actions.getAllFarmsList(nextProps.selectedYear);
    }
  }

  craeteRowData = rowData => {
    rowData= rowData.filter(value => value.id !="farmMgmtLink")
    return Object.keys(rowData).map(value => {
      let CurrentRow = rowData[value];
      let obj = {};
      var date = new Date(CurrentRow.updatedAt);
      obj["updatedAt"] = formatDate(date);
      obj["farmId"] = CurrentRow.farmId;
      obj["farmName"] = CurrentRow.farmName;
      obj["address"] = CurrentRow.address;
      obj["farmSize"] = CurrentRow.farmSize;
      obj["id"] = CurrentRow.id;
      obj["disabled"] = CurrentRow.disable ? CurrentRow.disable : false;
      return obj;
    });
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  deleteRow = id => {
    //this.props.actions.deleteContract(id);
  };

  editRow = id => {
    const { FarmsList } = this.props;
    const requiredData = FarmsList.find(farm => farm.id === id);
    this.props.actions.farmEditAction(requiredData);
  };

  render() {
    const { fetchingComplete, order, orderBy } = this.state;
    const { FarmsList, ErrorMessage } = this.props;
    const prevPath = "subFarmsList";
    return (
      <div className="ticket-body">
        <TabHeaderAndButton
          header="Farms"
          path="/createSubFarm"
          btnLabel="Create sub farms"
        />
        <div>
          {fetchingComplete ? (
            ErrorMessage && ErrorMessage.message ? (
              <div className="ErrorMessage">{ErrorMessage.message}</div>
            ) : (
              <CreateTable
                orderBy={orderBy}
                order={order}
                onRequestSort={this.handleRequestSort}
                headerRows={this.state.headerRows}
                rowData={this.craeteRowData(FarmsList)}
                location={`${prevPath}/edit`}
                //delete={this.deleteRow}
                edit={this.editRow}
              />
            )
          ) : (
            <Loader />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    user: state.user,
    FarmsList: state.FarmManagementReducer.FarmsList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...farmActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FarmsList);



// WEBPACK FOOTER //
// ./src/components/private/FarmManagment/FarmsList.js